import { emptyModal } from './consts';
import { SettingsState } from './types';

export const initialState: SettingsState = {
  value: 0,
  notifications: { nextKey: -1, list: [] },
  modal: emptyModal,
};
